import { render, staticRenderFns } from "./busqueda.vue?vue&type=template&id=3b3783f8"
import script from "./busqueda.vue?vue&type=script&lang=js"
export * from "./busqueda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports